var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01BmwSpeedometer5YcDeliveryAutomobiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilterpo",
    filterUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1-5y-mask",
    filter: "url(#Adobe_OpacityMaskFilterpo)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 22,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M82,327h-9v-2h9V327z M82,289h-9v33h9V289z M82,92h-9v194h9V92z M69,92h-9v235h9V92z M117,325h-9v2h9V325z  M117,282h-9v40h9V282z M117,81h-9v198h9V81z M104,81h-9v246h9V81z M152,325h-9v2h9V325z M152,279h-9v43h9V279z M152,79h-9v197h9 V79z M139,79h-9v248h9V79z M187,324h-9v3h9V324z M187,283h-9v38h9V283z M187,76h-9v204h9V76z M174,76h-9v251h9V76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y_1_",
    fill: "#006BB0",
    d: "M213,325h9v2h-9V325z M213,322h9v-26h-9V322z M213,95v198h9V95H213z M200,327h9V95h-9V327z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "rolls-royce-pin",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "221.5,325.5 227,314.5 290,314.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "mini-pin_1_",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "221.5,296.5 227,285.5 290,285.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "bmw-pin",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "221.5,95.5 227,84.5 290,84.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "total-pin_1_",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "208.5,95.5 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#006BB0",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-rolls-royce_1_",
    transform: "matrix(1 0 0 1 254.2285 310.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "3.756"), /*#__PURE__*/React.createElement("text", {
    id: "head-rolls-royce",
    transform: "matrix(1 0 0 1 20.1343 326.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Rolls-Royce"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-mini_2_",
    transform: "matrix(1 0 0 1 238.4229 281.5)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "292.582"), /*#__PURE__*/React.createElement("text", {
    id: "head-mini",
    transform: "matrix(1 0 0 1 39.5142 313.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "MINI"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-bmw",
    transform: "matrix(1 0 0 1 226.3599 79.6777)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "2.028.841"), /*#__PURE__*/React.createElement("text", {
    id: "head-bmw",
    transform: "matrix(1 0 0 1 37.436 274.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "BMW"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-total",
    transform: "matrix(1 0 0 1 226.2315 31.6777)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "2.325.179"), /*#__PURE__*/React.createElement("text", {
    id: "head-total",
    transform: "matrix(1 0 0 1 28.9595 82.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "  Gesamt"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.97,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Einheiten")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01BmwSpeedometer5YcDeliveryAutomobiles);
export default __webpack_public_path__ + "static/media/01_BMW_speedometer-5YC-delivery-automobiles.abf9f30f.svg";
export { ForwardRef as ReactComponent };